// Mutations do slice `journey`.
import { normalizeNivel } from '@modules/central-config/utils/progress'
import { normalizeGuideOrigin } from '@modules/central-config/utils/guide-origin'

export const SET_JOURNEY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.journey.data = {
      // Contrato: workspace é um objeto { office, professional } (não string).
      workspace: payload.workspace || { office: '', professional: '' },
      generatedAt: payload.generatedAt || '',
      modules: Array.isArray(payload.modules) ? payload.modules : [],
    }
    state.journey.lastUpdate = new Date()
  }
}

export const SET_JOURNEY_LOADING = (state, payload) => {
  state.journey.loading = !!payload
}

// Mutation do slice `guide`. Normaliza o payload para o shape fixo do drawer.
// `origin` passa por normalizeGuideOrigin: qualquer valor fora do vocabulário
// (ausente, 'modulo', undefined de um payload antigo) vira 'journey', que é o
// comportamento que já existia — é isso que mantém verdes os call-sites que não
// informam origem.
export const SET_GUIDE = (state, payload) => {
  const guide = payload || {}
  state.guide = {
    open: !!guide.open,
    collapsed: !!guide.collapsed,
    moduleId: guide.moduleId || null,
    taskId: guide.taskId || null,
    origin: normalizeGuideOrigin(guide.origin),
    moduleKey: guide.moduleKey || null,
  }
}

// Mutations do slice `stepTransition` — tint da linha + saída da lista na
// transição "Iniciar etapa".

export const SET_STEP_TRANSITION = (state, payload) => {
  const t = payload || {}
  state.stepTransition = {
    navigatingTaskId: t.navigatingTaskId || null,
    exitingModuleId: t.exitingModuleId || null,
  }
}

// Mutation do slice `nivelAtual` (spec-004). Converte o payload snake_case do
// backend (`nivel_atual`) para camelCase da casa e normaliza o shape — ausência
// de payload (backend antigo/fail-open) cai no Nível 1 sem progresso, nunca
// undefined, para o rail não quebrar.
// `normalizeNivel` (mesma função que agrupa módulos/etapas por nível) porque um
// valor fora do catálogo 1-4 sobrevivendo aqui não casa com nenhuma seção: a
// home renderiza rail + card sem NENHUMA seção e sem empty state — tela quebrada
// em silêncio.
export const SET_NIVEL_ATUAL = (state, payload) => {
  const n = payload || {}
  // `progresso_por_nivel` é descartado de propósito (ver state.js) — mesmo
  // tratamento que `definido_manualmente` já recebia.
  state.nivelAtual = {
    nivel: normalizeNivel(n.nivel),
  }
}

// Ponto a reabrir ao voltar do guia para a home da Jornada: `{ moduleId,
// taskId }`. Payload ausente/`null` limpa OS DOIS — é um estado só (de uso
// único), e sobreviver pela metade reabriria a home num nível que não é o da
// etapa de origem.
export const SET_RETURN_MODULE = (state, payload) => {
  const alvo = payload || {}
  state.returnToModuleId = alvo.moduleId || null
  state.returnToTaskId = alvo.taskId || null
}

// ---- Tour guiado (jornada guiada) ----
// Uma mutation só, com merge sobre o estado atual: as transições do tour são
// parciais (avançar mexe só no índice; o desfecho mexe em fase e marcação) e
// uma mutation por campo multiplicaria os pontos onde o shape pode divergir.
// O reset é explícito (SET_TOUR com null) para não depender de o chamador
// lembrar de zerar cada campo.
export const SET_TOUR = (state, payload) => {
  if (!payload) {
    state.tour = {
      ativo: false,
      moduleId: null,
      moduleKey: null,
      taskId: null,
      taskSlug: null,
      passos: [],
      proximaEtapa: null,
      indice: 0,
      fase: 'passos',
      recolheuGuia: false,
      marcarConcluida: true,
    }
    return
  }
  state.tour = { ...state.tour, ...payload }
}
